import * as IoC from 'inversify';
import { registerCommand } from '@/app/tracking/api';
import * as Api from '../api'
import { Scorm2004CompleteCourseCommandHandler } from './scorm2004-complete-course-command-handler';
import { Scorm2004UpdateCourseScoreCommandHandler } from './scorm2004-update-course-score-command-handler';
import { Scorm2004StartCourseCommandHandler } from './scorm2004-start-course-command-handler'
import { Scorm2004CloseCourseCommandHandler } from './scorm2004-close-course-command-handler'

export const courseScorm2004TrackingModule = new IoC.ContainerModule((bind) => {
  registerCommand(Api.StartCourseCommandName, Scorm2004StartCourseCommandHandler, bind);
  registerCommand(Api.CloseCourseCommandName, Scorm2004CloseCourseCommandHandler, bind);

  registerCommand(Api.CompleteCourseCommandName, Scorm2004CompleteCourseCommandHandler, bind);
  registerCommand(Api.UpdateCourseScoreCommandName, Scorm2004UpdateCourseScoreCommandHandler, bind);
})
